export const PaginationComponent = ({ total, range, pageSize, pageNumber }) => <>Page: {pageNumber}</>;
